export default "__VITE_ASSET__9da0eef0__"